import { useParams } from 'react-router'
import Page from '@/components/common/Page'
import OutreachTab from '@/pages/clients/ClientProviders/OutreachTab'

export default function OutreachPage() {
  const { clientId } = useParams<{ clientId: string }>()

  if (!clientId) return null

  return (
    <Page
      title="Outreach"
      helpContent={{
        header: 'Outreach Campaigns',
        body: (
          <div>
            <p>Manage and execute outreach emails generated by Sabar. Track the status and performance of your partnership efforts.</p>
            <h4>Features:</h4>
            <ul style={{ marginLeft: 20 }}>
              <li>View all generated outreach emails</li>
              <li>Preview personalized content before sending</li>
              <li>Track send status and responses</li>
              <li>Filter by status (pending, sent, replied)</li>
            </ul>
            <h4>What to Do:</h4>
            <p>Review email quality and personalization. Approve to send or modify before sending. Track replies to measure effectiveness.</p>
          </div>
        ),
      }}
    >
      <OutreachTab clientId={clientId} />
    </Page>
  )
}
